import { inArray } from "jquery";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { FacebookShareButton } from "react-share";
import { getSelectedCity } from "../../constant/utils";
import { centerAction, dashboardAction } from "../../redux/action";
import { ROUTE } from "../../route/Route";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import CentresMap from "./CentresMap";
import SeoAdd from "../Seo/SeoAdd";
import { useTranslation } from "react-i18next";
import SectionLoader from "../LodingScreen/SectionLoader";

const Labs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation<any>();
  const [limit, setLimit] = useState<any>(20);
  const [increseBy, setIncreseBy] = useState<any>(20);
  const [related, setRelated] = useState<boolean>(false);
  const [stateId, setStateId] = useState("");
  console.log("fdx");
  
  const [cityId, setCityId] = useState<any>("");
  const [pincode, setPincode] = useState<any>("");
  const [locality, setLocality] = useState<any>("");
  const [search, setSearch] = useState<any>("");
  const [searchTermShow, setSearchTermShow] = useState<any>("");
  const [findByPincode, setFindByPincode] = useState<any>("");
  const [localStoreCity, setLocalStoreCity] = useState<any>("");
  const [excludedCentreIds, setExcludedCentreIds] = useState<any>([]);
  const centerData: any = useSelector((state: any) =>
    state.center.list ? state.center.list : {}
  );
  const nearCenterData = useSelector((state: any) =>
    state.center.relatedCentre ? state.center.relatedCentre : []
  );
  const state: any[] = useSelector((state: any) => state.dashboard.state);
  const city: any[] = useSelector((state: any) => state.dashboard.cityAll);
  const nearestCenters = localStoreCity == "" ? nearCenterData : [];
  const [CentreType, setCentreType] = useState<any>("");
  const [zoneType, setZoneType] = useState<any>("");
  const cityByState = (Array.isArray(city) ? city : []).filter(
    (item: any) => String(item.StateId) === stateId
  );

  useEffect(() => {
    window?.scrollTo(0, 0);
    setLocalStoreCity(getSelectedCity());
    setSearch("");
    setStateId("");
    setCityId("");
    setPincode("");
    setLimit(20);
    setLocality("");
    setSearchTermShow("");
    setFindByPincode("");
    setRelated(false);
    let data: any = {};
    data.CityId = getSelectedCity();
    data.Offset = 0;
    data.Limit = 20;
    dispatch(centerAction.listCenterAction(data));
    return () => {};
  }, [getSelectedCity()]);

  useEffect(() => {
    dispatch(dashboardAction.getStateAction({ zone: "" }));
  }, [dispatch]);
  useEffect(() => {
    if (related && centerData?.Centres?.length > 0) {
      let CentreType = centerData?.Centres?.[0].CentreType;
      let StateId = centerData?.Centres?.[0].StateId;
      let CityId = centerData?.Centres?.[0].CityId;
      dispatch(
        centerAction.getRelatedCentreAction({
          CentreType: CentreType,
          StateId: StateId,
          CityId: CityId,
        })
      );
    }
    return () => {};
  }, [centerData]);

  const handleLimit = (e: any) => {
    e.preventDefault();
    setLimit(limit + increseBy);
  };

  useEffect(() => {
    if (limit > 21) {
      window?.scrollTo(0, 0);
      let data: any = {};
      if (search) {
        data.LatLng = search;
      } else if (stateId || cityId) {
        data.StateId = stateId;
        data.CityId = cityId;
      } else if (pincode) {
        data.Pincode = pincode;
      } else if (locality) {
        data.SearchTeam = locality;
      } else {
        data.CityId = localStoreCity;
      }
      data.Offset = 0;
      data.Limit = limit;
      dispatch(centerAction.listCenterAction(data));
    }
    return () => {};
  }, [limit]);

  const handlelabtype = (e: any) => {
    setCentreType(e.target.value);
    let data: any = {};
    data.CentreType = e.target.value;
    data.Offset = 0;
    data.Limit = 20;
    dispatch(centerAction.listCenterAction(data));
  };
  const handlezone = (e: any) => {
    setZoneType(e.target.value);
    setStateId("");
    setCityId("");
    let data: any = {};
    data.zone = e.target.value;
    dispatch(centerAction.listCenterAction(data));
    dispatch(dashboardAction.getStateAction({ zone: e.target.value }));
  };

  const handleStateChange = (e: any) => {
    setStateId(e.target.value);
    setCityId("");
    setSearch("");
    setPincode("");
    setRelated(false);
    setLimit(20);
    setLocality("");
    setSearchTermShow("");
    setFindByPincode("");
    let data: any = {};
    data.StateId = e.target.value;
    data.Offset = 0;
    data.Limit = 20;
    dispatch(centerAction.listCenterAction(data));
  };

  const handleSelectCity = (e: any) => {
    setCityId(e.target.value);
    setRelated(false);
    setLimit(20);
    let data: any = {};
    data.StateId = stateId;
    data.CityId = e.target.value;
    data.Offset = 0;
    data.Limit = 20;
    dispatch(centerAction.listCenterAction(data));
  };

  const handleGetUserLatLng = async (e: any) => {
    e.preventDefault();
    if (navigator?.geolocation) {
      await navigator?.geolocation.getCurrentPosition(
        (position: any) => {
          let data: any = `${position.coords.latitude},${position.coords.longitude}`;
          setSearch(data);
          setStateId("");
          setCityId("");
          setPincode("");
          setLimit(20);
          setLocality("");
          setSearchTermShow("");
          setFindByPincode("");
          dispatch(
            centerAction.listCenterAction({
              LatLng: data,
              Offset: 0,
              Limit: 20,
            })
          );
          localStorage.setItem("UserLatLng", data);
        },
        (err: any) => console.log(err),
        { timeout: 5000 }
      );
    } else {
      alert(
        "your Browser does not support location, Please add your address manually"
      );
    }
  };
  useEffect(() => {
    setExcludedCentreIds((centerData?.Centres || []).map((item: any) => item?.Id));
  }, [centerData]);

  const handleSearch = (e: any) => {
    setRelated(false);
    let val = e.target.value;
    val = val && val?.trim();
    setSearch("");
    setSearchTermShow(val);
    setFindByPincode("");
    setSearch("");
    setStateId("");
    setCityId("");
    setLimit(20);
    if (val && val.length >= 3) {
      if (!isNaN(val)) {
        if (val.length >= 6) {
          setPincode(val);
          dispatch(
            centerAction.listCenterAction({
              Pincode: val,
              Offset: 0,
              Limit: 20,
            })
          );
          setRelated(true);
        }
      } else {
        setLocality(val);
        dispatch(
          centerAction.listCenterAction({
            SearchTeam: val,
            Offset: 0,
            Limit: 20,
          })
        );
      }
    }
    if (val.length === 0) {
      setLocality("");
      setPincode("");
      dispatch(
        centerAction.listCenterAction({
          SearchTeam: "",
          Pincode: "",
          Offset: 0,
          Limit: limit,
        })
      );
      // setRelated(true);
    }
  };
  const findCityName = () => {
    let _id = stateId ? cityId : localStoreCity;
    let dt = city.find((ele) => ele.Id == _id);
    return dt?.Name || "";
  };
  return (
    <>
      <SeoAdd slug={ROUTE.CENTER?.replace("/", "")} />
      <BreadCrumb page={t("lab_centres")} data={{ slug: "", path: "" }} />
      <section className="bg-white section  pt-3">
        <div className="container">
          <div className="row">
            <div className="col-md-3">
              <div className="headingmains text-left">
                <h3 className="right aos-init pb-2">{t("center_heading")}</h3>
              </div>
            </div>
            <div className="col-md-9">
              <div className="row">
                <div className="col-sm-2">
                  <div className="form-group">
                    <select
                      className="form-control rounded-pill"
                      value={CentreType}
                      aria-label="Lab Type"
                      onChange={(e: any) => handlelabtype(e)}
                    >
                      <option value="">{t("lab_type")}</option>
                      <option value="1">Oncquest Collection Centre</option>
                      <option value="2">Oncquest Labs</option>
                      <option value="3">PSC</option>
                      {/* <option value="4">Lab on Lease</option> */}
                      <option value="5">HLM</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-2">
                  <div className="form-group">
                    <select
                      className="form-control rounded-pill"
                      value={zoneType}
                      aria-label="Zone"
                      onChange={(e: any) => handlezone(e)}
                    >
                      <option value="">Select Zone</option>
                      <option value="east">east</option>
                      <option value="west">west</option>
                      <option value="north">north</option>
                      <option value="south">south</option>
                    </select>
                  </div>
                </div>
                <div className="col-sm-2">
                  <div className="form-group">
                    <select
                      className="form-control rounded-pill"
                      value={stateId}
                      aria-label="State"
                      onChange={(e: any) => handleStateChange(e)}
                    >
                      <option value="">{t("select_state")}</option>
                      {state &&
                        state?.length > 0 &&
                        state?.map((item: any) => (
                          <option
                            className="text-uppercase"
                            value={item?.Id}
                            key={item?.Id}
                          >
                            {t(item?.Name)}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-sm-2">
                  <div className="form-group">
                    <select
                      className="form-control rounded-pill"
                      value={cityId}
                      aria-label="City"
                      disabled={!stateId}
                      onChange={(e: any) => handleSelectCity(e)}
                    >
                      <option value="">{stateId ? t("select_city") : "Select state first"}</option>
                      {cityByState &&
                        stateId &&
                        cityByState?.length > 0 &&
                        cityByState?.map((item: any) => (
                          <option
                            className="text-uppercase"
                            value={item?.Id}
                            key={item?.Id}
                          >
                            {t(item?.Name)}
                          </option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className="col-md-4">
                  <div
                    className="row"
                    style={{ position: "relative", zIndex: 31 }}
                  >
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="input-group">
                          <span className="input-group-prepend">
                            <div className="input-group-text border-0 bg-transparent mr-n5">
                              <i className="fa fa-search"></i>
                            </div>
                          </span>
                          <input
                            className="form-control rounded-pill py-1 pl-5 ml-1 bg-transparent"
                            type="search"
                            placeholder={t("search_locality_pincode")}
                            value={searchTermShow}
                            onChange={(e: any) => handleSearch(e)}
                            id="example-search-input"
                          />
                        </div>
                      </div>
                    </div>
                    {/* <div className="col-sm-4">
                                        <div className="form-group">
                                            <a href='#' onClick={(e: any) => handleGetUserLatLng(e)}>
                                                <img className="scale nearby_icon" src="/assets/img/loc_icon.png" width="17.3px" height="17.3px" />
                                                <button placeholder="Nearby" style={{ color: "#495057" }} className="form-control  rounded-pill py-2 pl-2 ml-1 bg-transparent">Nearby</button>
                                            </a>
                                        </div>
                                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-7">
              <div className="lab_list h-services">
                <img src={t("images.center_banner")} className="scale" alt="" />
              </div>
              {Object.keys(centerData).length > 0 ? (
                <>
                  {centerData && centerData?.Centres?.length > 0 ? (
                    centerData?.Centres?.map((item: any, index: any) => (
                      <>
                        <div className="lab_list h-services" key={index}>
                          <div className="infobox_wrapper lab_wrapper know-lab">
                            <div className="lab_flex_pad">
                              <div>
                                <img
                                  src="/assets/img/test.png"
                                  className="scale_booknow"
                                />
                                {t(item?.DisplayCentreName)}
                              </div>
                              <div className="lab_flex_center">
                                <FacebookShareButton
                                  url={`${window.location.host}${ROUTE.CENTERDETAILS}/${item?.Slug}`}
                                >
                                  <div className="mr-3">
                                    <img
                                      src="/assets/img/share.png"
                                      className="scale_booknow"
                                    />
                                    {t("share")}
                                  </div>
                                </FacebookShareButton>
                                <a
                                  href={`https://www.google.com/maps/search/?api=1&query=${item?.CentreLat},${item?.CentreLng}`}
                                  target="_blank"
                                >
                                  <img
                                    src="/assets/img/direction.png"
                                    className="scale_booknow"
                                  />
                                  {t("get_direction")}
                                </a>
                              </div>
                            </div>
                            <div className="address">
                              {item?.AddressLine1
                                ? item?.AddressLine1 + ", "
                                : ""}
                              {item?.AddressLine2
                                ? item?.AddressLine2 + ", "
                                : ""}
                              {item?.Landmark ? item?.Landmark + ", " : ""}
                              {item?.Locality ? item?.Locality + ", " : ""}
                              {item?.CityName ? item?.CityName + ", " : ""}
                              {item?.Pincode ? item?.Pincode + "- " : ""}
                              {item?.StateName ? item?.StateName : ""}
                            </div>
                            <div className="lab_flex_start">
                              {/* {item?.Phone &&
                                                            <div className="lab_flex_center">
                                                                <span><img src="/assets/img/call.png" className="scale_booknow" /></span>
                                                                <span>
                                                                    <div>{t("phone_number")}</div>
                                                                    <div className="text"><a href={`tel: ${item?.Phone}`} target="_blank">{`(+91) ${item?.Phone}`}</a></div>
                                                                </span>
                                                            </div>
                                                        } */}
                              {/* {item?.CentreTimings &&
                                                            <div className="lab_flex_center">
                                                                <span><img src="/assets/img/clock.png" className="scale_booknow" /></span>
                                                                <CenterTiming timing={item?.CentreTimings} />
                                                            </div>
                                                        } */}
                              {/* {item?.Email &&
                                                            <div className="lab_flex_center">
                                                                <span><img src="/assets/img/email.png" className="scale_booknow" /></span>
                                                                <span>
                                                                    <div>{t("email")}</div>
                                                                    <a className="text" href={`mailto: ${item?.Email}`}>{item?.Email}</a>
                                                                </span>
                                                            </div>
                                                        } */}
                            </div>
                            <Link
                              className="button-read-more pt-2 pb-2 text-dark f-15"
                              to={`${ROUTE.CENTERDETAILS}/${item?.Slug}`}
                            >
                              {t("know_more")}
                              <img
                                src="assets/img/arrow-read-dark.svg"
                                className="scale_booknow ml-3"
                              />
                            </Link>
                          </div>
                        </div>
                      </>
                    ))
                  ) : (
                    <div className="lab_list h-services">
                      <div className="infobox_wrapper text-center fs-16">
                        {t("no_centre_found")} {t(findCityName())}
                      </div>
                    </div>
                  )}

                  {centerData?.TotalCentres > limit &&
                    centerData?.Centres?.length >= limit && (
                      <div className="text-center my-4">
                        <a
                          href="#"
                          onClick={(e: any) => handleLimit(e)}
                          className="button--hexagon normal active"
                        >
                          <span className="text-capitalize">
                            {" "}
                            {t("load_more")}
                          </span>
                        </a>
                      </div>
                    )}
                </>
              ) : (
                <SectionLoader />
              )}
              {nearestCenters && nearestCenters?.Centres?.length > 0 ? (
                <h6 className="pb-3">Other Labs/Centers</h6>
              ) : (
                ""
              )}

              {nearestCenters && nearestCenters?.Centres?.length > 0 ? (
                nearestCenters?.Centres?.map((item: any, index: any) =>
                  excludedCentreIds.includes(item?.Id) == false ? (
                    <>
                      <div className="lab_list h-services" key={index}>
                        <div className="infobox_wrapper lab_wrapper">
                          <div className="lab_flex_pad">
                            <div>
                              <img
                                src="/assets/img/test.png"
                                className="scale_booknow"
                              />
                              {item?.DisplayCentreName}
                            </div>
                            <div className="lab_flex_center">
                              <FacebookShareButton
                                url={`${window.location.host}${ROUTE.CENTERDETAILS}/${item?.Slug}`}
                              >
                                <div className="mr-3">
                                  <img
                                    src="/assets/img/share.png"
                                    className="scale_booknow"
                                  />
                                  {t("share")}
                                </div>
                              </FacebookShareButton>
                              <a
                                href={`https://www.google.com/maps/search/?api=1&query=${item?.CentreLat},${item?.CentreLng}`}
                                target="_blank"
                              >
                                <img
                                  src="/assets/img/direction.png"
                                  className="scale_booknow"
                                />
                                {t("get_direction")}
                              </a>
                            </div>
                          </div>
                          <div className="address">
                            {item?.AddressLine1
                              ? item?.AddressLine1 + ", "
                              : ""}
                            {item?.AddressLine2
                              ? item?.AddressLine2 + ", "
                              : ""}
                            {item?.Landmark ? item?.Landmark + ", " : ""}
                            {item?.Locality ? item?.Locality + ", " : ""}
                            {item?.CityName ? item?.CityName + ", " : ""}
                            {item?.Pincode ? item?.Pincode + "- " : ""}
                            {item?.StateName ? item?.StateName : ""}
                          </div>
                          <div className="lab_flex_start">
                            {/* {item?.Phone &&
                                                            <div className="lab_flex_center">
                                                                <span><img src="/assets/img/call.png" className="scale_booknow" /></span>
                                                                <span>
                                                                    <div>{t("phone_number")}</div>
                                                                    <div className="text"><a href={`tel: ${item?.Phone}`} target="_blank">{`(+91) ${item?.Phone}`}</a></div>
                                                                </span>
                                                            </div>
                                                        } */}
                            {/* {item?.CentreTimings &&
                                                            <div className="lab_flex_center">
                                                                <span><img src="/assets/img/clock.png" className="scale_booknow" /></span>
                                                                <CenterTiming timing={item?.CentreTimings} />
                                                            </div>
                                                        } */}
                            {/* {item?.Email &&
                                                            <div className="lab_flex_center">
                                                                <span><img src="/assets/img/email.png" className="scale_booknow" /></span>
                                                                <span>
                                                                    <div>Email Id</div>
                                                                    <a className="text" href={`mailto: ${item?.Email}`}>{item?.Email}</a>
                                                                </span>
                                                            </div>
                                                        } */}
                          </div>
                          <Link
                            className="button-read-more pt-2 pb-2 text-dark f-15"
                            to={`${ROUTE.CENTERDETAILS}/${item?.Slug}`}
                          >
                            {t("know_more")}
                            <img
                              src="assets/img/arrow-read-dark.svg"
                              className="scale_booknow ml-3"
                            />
                          </Link>
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )
                )
              ) : (
                <div
                  style={{
                    display: nearestCenters?.Centres?.length > 0 ? "" : "none",
                  }}
                  className="lab_list h-services"
                >
                  <div className="infobox_wrapper text-center fs-16">
                    No Nearby Centre Found
                  </div>
                </div>
              )}
            </div>
            <div className="col-md-5">
              {Object.keys(centerData).length > 0 ? (
                <CentresMap centres={centerData?.Centres || []} />
              ) : (
                <SectionLoader />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Labs;
